'use client'

import type { LucideIcon } from 'lucide-react'

import parse from 'html-react-parser'

import { Card, CardContent } from '@/components/ui/card'

type PolicyPageContentProps = {
  content: string | undefined
  emptyIcon: LucideIcon
  emptyStateLabel: string
  lang: 'ar' | 'en'
}

/**
 * Renders policy HTML content or an empty state.
 * Used by Privacy Policy and Terms & Conditions pages.
 */
export function PolicyPageContent({
  content,
  emptyIcon: EmptyIcon,
  emptyStateLabel,
  lang
}: PolicyPageContentProps) {
  const hasContent = !!content

  if (!hasContent) {
    return (
      <Card>
        <CardContent className="flex min-h-[400px] items-center justify-center">
          <div className="space-y-3 text-center">
            <EmptyIcon
              aria-hidden
              className="text-muted-foreground/40 mx-auto h-10 w-10"
            />
            <p className="text-muted-foreground">{emptyStateLabel}</p>
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent className="p-6" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
        <div className="policy-html text-foreground [&_a]:text-primary max-w-none [&_a]:underline [&_h1]:mb-4 [&_h1]:text-xl [&_h2]:mb-3 [&_h2]:text-lg [&_h3]:mb-2 [&_h3]:text-base [&_ol]:list-decimal [&_ol]:ps-6 [&_p]:mb-2 [&_ul]:list-disc [&_ul]:ps-6">
          {parse(String(content))}
        </div>
      </CardContent>
    </Card>
  )
}
